module.exports = __webpack_public_path__ + "img/suggest.d52a4a9c.svg";